import { isSlaPausedStatus } from './slaCountdown';

/** C3 — statuses that block manual Inquiry Matrix escalation (mirrors backend). */
const MANUAL_MATRIX_ESCALATION_BLOCKED_STATUS_CODES = new Set([
  'resolved',
  'closed',
  'escalated',
  'pending_customer',
  'pending_customer_response',
  'pending_supervisor_approval',
  'supervisor_approved',
]);

export const normalizeTicketStatusCode = (ticket) => {
  const raw =
    ticket?.statusCode ||
    ticket?.status?.statusCode ||
    ticket?.status?.code ||
    ticket?.status ||
    '';
  return String(raw).toLowerCase().replace(/[\s-]+/g, '_');
};

export const isManualMatrixEscalationEligible = (ticket) => {
  if (!ticket) return false;
  const hasInquiryMasters =
    ticket.inquiryTypeId != null
    && ticket.inquiryCategoryId != null
    && ticket.inquirySubCategoryId != null
    && ticket.inquiryPriorityLevelId != null;
  if (!hasInquiryMasters) return false;
  if (ticket.slaApplicable !== true || !ticket.dueDate) return false;
  if (ticket.assigneeId == null && ticket.assignee_id == null) return false;
  if (!ticket.assignedTime && !ticket.assigned_time) return false;
  const statusCode = normalizeTicketStatusCode(ticket);
  if (MANUAL_MATRIX_ESCALATION_BLOCKED_STATUS_CODES.has(statusCode)) return false;
  if (isSlaPausedStatus(statusCode)) return false;
  return true;
};
